import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userAPI } from '../services/api';
import './Auth.css';
import './Profile.css';

function Profile() {
  const navigate = useNavigate();

  const [perfil, setPerfil] = useState(null);
  const [loadingPerfil, setLoadingPerfil] = useState(true);
  const [erroPerfil, setErroPerfil] = useState('');

  const [fullName, setFullName] = useState('');
  const [salvandoNome, setSalvandoNome] = useState(false);
  const [mensagemNome, setMensagemNome] = useState('');

  const [modalSenhaAberto, setModalSenhaAberto] = useState(false);
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [salvandoSenha, setSalvandoSenha] = useState(false);
  const [erroSenha, setErroSenha] = useState('');
  const [sucessoSenha, setSucessoSenha] = useState('');

  useEffect(() => {
    const carregar = async () => {
      try {
        const { data } = await userAPI.getMe();
        setPerfil(data);
        setFullName(data.full_name || '');
      } catch {
        setErroPerfil('Erro ao carregar perfil.');
      } finally {
        setLoadingPerfil(false);
      }
    };
    carregar();
  }, []);

  const handleSalvarNome = async (e) => {
    e.preventDefault();
    setMensagemNome('');
    setSalvandoNome(true);
    try {
      const { data } = await userAPI.updateProfile({ full_name: fullName });
      setPerfil(data);
      setMensagemNome('Nome atualizado.');
      setTimeout(() => setMensagemNome(''), 2500);
    } catch {
      setMensagemNome('Erro ao salvar.');
    } finally {
      setSalvandoNome(false);
    }
  };

  const handleAlterarSenha = async (e) => {
    e.preventDefault();
    setErroSenha('');
    setSucessoSenha('');

    if (novaSenha.length < 8) {
      setErroSenha('A nova senha deve ter no mínimo 8 caracteres.');
      return;
    }
    if (novaSenha !== confirmacao) {
      setErroSenha('As senhas não conferem.');
      return;
    }

    setSalvandoSenha(true);
    try {
      await userAPI.changePassword(senhaAtual, novaSenha);
      setSucessoSenha('Senha alterada com sucesso.');
      setSenhaAtual('');
      setNovaSenha('');
      setConfirmacao('');
      setTimeout(() => {
        setModalSenhaAberto(false);
        setSucessoSenha('');
      }, 2000);
    } catch (err) {
      setErroSenha(err.response?.data?.detail || 'Erro ao alterar senha.');
    } finally {
      setSalvandoSenha(false);
    }
  };

  const fecharModalSenha = () => {
    setModalSenhaAberto(false);
    setErroSenha('');
    setSucessoSenha('');
    setSenhaAtual('');
    setNovaSenha('');
    setConfirmacao('');
  };

  if (loadingPerfil) {
    return <div className="profile-loading">Carregando...</div>;
  }

  if (erroPerfil) {
    return <div className="profile-error">{erroPerfil}</div>;
  }

  return (
    <div className="profile-container">
      <div className="profile-card">
        <div className="profile-header">
          <h2>Meu perfil</h2>
          <button onClick={() => navigate('/')} className="link-button">
            ← Voltar
          </button>
        </div>

        <div className="profile-section">
          <h3>Dados da conta</h3>
          <div className="profile-field">
            <label>Usuário</label>
            <div className="profile-value">{perfil.username}</div>
          </div>
          <div className="profile-field">
            <label>Email</label>
            <div className="profile-value">{perfil.email}</div>
            <small>Para alterar o email, contate o administrador.</small>
          </div>
          <div className="profile-field">
            <label>Conta criada em</label>
            <div className="profile-value">
              {new Date(perfil.created_at).toLocaleDateString('pt-BR')}
            </div>
          </div>
        </div>

        <form onSubmit={handleSalvarNome} className="profile-section">
          <h3>Nome completo</h3>
          <div className="form-group">
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              placeholder="Seu nome completo"
            />
          </div>
          <button type="submit" className="auth-button" disabled={salvandoNome}>
            {salvandoNome ? 'Salvando...' : 'Salvar nome'}
          </button>
          {mensagemNome && <div className="profile-message">{mensagemNome}</div>}
        </form>

        <div className="profile-section">
          <h3>Segurança</h3>
          <button onClick={() => setModalSenhaAberto(true)} className="auth-button">
            Alterar senha
          </button>
        </div>
      </div>

      {modalSenhaAberto && (
        <div className="profile-modal-overlay" onClick={fecharModalSenha}>
          <div className="profile-modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Alterar senha</h3>
            <form onSubmit={handleAlterarSenha}>
              {erroSenha && <div className="auth-error">{erroSenha}</div>}
              {sucessoSenha && (
                <div className="auth-message auth-message-success">{sucessoSenha}</div>
              )}

              <div className="form-group">
                <label>Senha atual</label>
                <input
                  type="password"
                  value={senhaAtual}
                  onChange={(e) => setSenhaAtual(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label>Nova senha</label>
                <input
                  type="password"
                  value={novaSenha}
                  onChange={(e) => setNovaSenha(e.target.value)}
                  placeholder="Mínimo 8 caracteres"
                  required
                />
              </div>

              <div className="form-group">
                <label>Confirmar nova senha</label>
                <input
                  type="password"
                  value={confirmacao}
                  onChange={(e) => setConfirmacao(e.target.value)}
                  required
                />
              </div>

              <div className="profile-modal-actions">
                <button
                  type="button"
                  onClick={fecharModalSenha}
                  className="auth-button profile-btn-secondary"
                  disabled={salvandoSenha}
                >
                  Cancelar
                </button>
                <button type="submit" className="auth-button" disabled={salvandoSenha}>
                  {salvandoSenha ? 'Salvando...' : 'Confirmar'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Profile;
